import React, { memo } from 'react';

//日本語
import 'budoux/module/webcomponents/budoux-ja';
//中国語（簡体語）
import 'budoux/module/webcomponents/budoux-zh-hans';
//中国語（繁体語）
import 'budoux/module/webcomponents/budoux-zh-hant';

import i18n from '../../assets/languages/configs';
import styles from './styles.module.css';

const TextBreaks = memo(({ text }: { text: string }) => {
    const { language } = i18n;

    let content;
    switch (language) {
        case 'ja': //日本語
            content = React.createElement('budoux-ja', null, text);
            break;
        case 'zh': //中国語（簡体語）
            content = React.createElement('budoux-zh-hans', null, text);
            break;
        case 'zh-TW': //中国語（繁体語）
            content = React.createElement('budoux-zh-hant', null, text);
            break;
        default:
            content = text;
            break;
    }

    return <span className={styles.breakWord}>{content}</span>;
});

export default TextBreaks;
